import type { MouseEvent } from "react";
import { navLinks, footerNote } from "@/mocks/movieContent";

export default function SiteFooter() {
  const go = (id: string) => (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr] gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">姐姐的朋友电影</span>
            </div>
            <p className="mt-4 text-sm text-background-100/80 leading-relaxed max-w-md">
              一个围绕这部影片的资料与评论整理页：包含影评、解说、剧情介绍与观后感的集中说明，
              帮助你在最短时间内了解它讲了什么、为什么会被讨论。
            </p>
            <p className="mt-4 text-xs text-background-100/60 leading-relaxed max-w-md">{footerNote}</p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50 tracking-wide">本页导航</h3>
            <nav className="mt-4 grid grid-cols-2 gap-y-2.5 gap-x-4">
              {navLinks.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={go(item.id)}
                  className="text-sm text-background-100/80 cursor-pointer transition-colors hover:text-accent-300"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-100/60">© {year} 姐姐的朋友电影 · 影评解说整理</p>
          <p className="text-xs text-background-100/60">内容仅供学习与交流，请理性观影</p>
        </div>
      </div>
    </footer>
  );
}